import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { PhotographerService } from '../../services/photographer.service';
import { PhotographerComponent } from './components/photographer.component';
import { SharedModule } from '../../shared/shared.module';
import { PhotographerRouting } from './photographer.routing';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { PhotographerOrderList } from './components/photographer-order-list/photographer-order-list';
import { MatIconModule } from '@angular/material/icon';
import { PhotographerOrderDetailComponent } from './components/photographer-order-detail/photographer-order-detail';
import { PhotographerOrderDetailShotsComponent } from './components/photographer-order-detail/photographer-order-detail-shots/photographer-order-detail-shots';
import { PhotographerOrderDetailInfoComponent } from './components/photographer-order-detail/photographer-order-detail-info/photographer-order-detail-info';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ImagePreviewModalComponent } from './components/photographer-order-detail/photographer-order-detail-shots/image-preview-modal/image-preview-modal.component';
import { UploadMultipleModalComponent } from './components/photographer-order-detail/photographer-order-detail-shots/upload-multiple-modal/upload-multiple-modal.component';
import { UploadMultipleWithOrchestratorModalComponent } from './components/photographer-order-detail/photographer-order-detail-shots/upload-multiple-with-orchestrator-modal/upload-multiple-with-orchestrator-modal.component';
import { UploadValidationResultsModalComponent } from './components/photographer-order-detail/photographer-order-detail-shots/upload-multiple-with-orchestrator-modal/upload-validation-results-modal/upload-validation-results-modal.component';
import { EstimatedNameModalComponent } from './components/photographer-order-detail/photographer-order-detail-shots/upload-multiple-with-orchestrator-modal/estimated-name-modal/estimated-name-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    MatIconModule,
    MatDatepickerModule,
    PhotographerRouting,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
	MatTooltipModule
  ],
  declarations: [
    PhotographerComponent,
    PhotographerOrderList,
    PhotographerOrderDetailComponent,
    PhotographerOrderDetailInfoComponent,
    PhotographerOrderDetailInfoComponent,
    PhotographerOrderDetailShotsComponent,
    ImagePreviewModalComponent,
    UploadMultipleModalComponent,
    UploadMultipleWithOrchestratorModalComponent,
    UploadValidationResultsModalComponent,
    EstimatedNameModalComponent
  ],
  exports: [PhotographerComponent],
  providers: [PhotographerService, CommonService]
})
export class PhotographerModule {}
